export interface AirlineSbbPrefillData {
  departure: any;
  destination: any;
  departureDate: string | null;
  departureTime: string | null;
}

export const getAirlineSbbPrefillData = (locationState: any): AirlineSbbPrefillData | null => {
  if (locationState?.meta?.source !== "airline") {
    return null;
  }

  return {
    departure: locationState?.typeSpecific?.details?.departure || null,
    destination: locationState?.typeSpecific?.details?.destination || null,
    departureDate: locationState?.shared?.departureDate || null,
    departureTime: locationState?.shared?.time || null
  };
};
